import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { JiraAttachment } from './types.tsx';

const getAttachmentApiUrl = (attachmentId: number): string =>
	`/rest/api/3/attachment/${attachmentId}`;

export const getAttachment = (attachmentId: number): Promise<JiraAttachment> =>
	fetchJson(getAttachmentApiUrl(attachmentId));
